import { TicketDeliveryMethod } from '@pages/event/api/useSendMessages';

export const calculateMessageParts = (message: string): number => {
  if (!message.length) return 0;
  return message.length <= 20 ? 1 : 2;
};

export const calculateInvitationCounts = (
  invitationDeliveryMethod: TicketDeliveryMethod | null,
  ticketsCount: number,
  messageParts: number
): { email: number; sms: number } => {
  if (!invitationDeliveryMethod) return { email: 0, sms: 0 };

  switch (invitationDeliveryMethod) {
    case TicketDeliveryMethod.SMS:
      return { email: 0, sms: ticketsCount * messageParts };
    case TicketDeliveryMethod.Email:
      return { email: ticketsCount, sms: 0 };
    case TicketDeliveryMethod.Both:
      return { email: ticketsCount, sms: ticketsCount * messageParts };
    default:
      return { email: 0, sms: 0 };
  }
};

export const calculateTicketCounts = (
  ticketDeliveryMethod: TicketDeliveryMethod | null,
  ticketsCount: number,
  ticketMessageParts: number
): { email: number; sms: number } => {
  if (!ticketDeliveryMethod) return { email: 0, sms: 0 };

  switch (ticketDeliveryMethod) {
    case TicketDeliveryMethod.SMS:
      return { email: 0, sms: ticketsCount * ticketMessageParts };
    case TicketDeliveryMethod.Email:
      return { email: ticketsCount, sms: 0 };
    case TicketDeliveryMethod.Both:
      return { email: ticketsCount, sms: ticketsCount * ticketMessageParts };
    default:
      return { email: 0, sms: 0 };
  }
};
